export default [
    {
        path: 'balancete',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-balancete' */
            '@/views/almoxarifado/balancete/Index'
        ),
        redirect: 'balancete/index',
        children: [
            {
                name: 'almoxarifado-balancete-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-balancete' */
                    '@/views/almoxarifado/balancete/List.vue'
                ),
            },
        ],
    },
]